import { useRef } from "react"
import { useFrame } from "@react-three/fiber"
import * as THREE from "three"

interface TargetIndicatorProps {
    target: [number, number, number]
    color?: string
}

// Anillo hexagonal pulsante en el suelo donde el tripulante va a llegar.
// Geometría hex (6 segmentos en ringGeometry) — alineada con la estética del sello.
export function TargetIndicator({
    target,
    color = "#D4AF37",
}: TargetIndicatorProps) {
    const ringRef = useRef<THREE.Mesh>(null)
    const innerRef = useRef<THREE.Mesh>(null)
    const innerMatRef = useRef<THREE.MeshBasicMaterial>(null)

    useFrame((state) => {
        const t = state.clock.elapsedTime
        if (ringRef.current) {
            ringRef.current.rotation.z += 0.012
            const pulse = 1 + Math.sin(t * 2.4) * 0.1
            ringRef.current.scale.set(pulse, pulse, 1)
        }
        if (innerMatRef.current) {
            innerMatRef.current.opacity = 0.12 + (Math.sin(t * 3) + 1) * 0.08
        }
        if (innerRef.current) {
            innerRef.current.rotation.z -= 0.018
        }
    })

    return (
        <group
            position={[target[0], 0.025, target[2]]}
            rotation={[-Math.PI / 2, 0, 0]}
        >
            <mesh ref={ringRef}>
                <ringGeometry args={[0.55, 0.7, 6]} />
                <meshBasicMaterial
                    color={color}
                    transparent
                    opacity={0.9}
                    side={THREE.DoubleSide}
                />
            </mesh>
            <mesh ref={innerRef}>
                <ringGeometry args={[0, 0.55, 6]} />
                <meshBasicMaterial
                    ref={innerMatRef}
                    color={color}
                    transparent
                    opacity={0.2}
                    side={THREE.DoubleSide}
                />
            </mesh>
        </group>
    )
}
